import React from 'react';
import {
	FormattedMessage,
	defineMessages,
} from 'react-intl';

import CancelButton from '~/components/app/CancelButton';
import Form from '~/components/atoms/forms/basis/Form';
import ButtonsLayout from '~/components/patterns/buttons/ButtonsLayout';
import ModalContainer from '~/components/atoms/modals/parts/ModalContainer';
import ModalHeader from '~/components/patterns/modals/parts/ModalHeader';
import SubmitButton from '~/components/app/SubmitButton';

import {
	useRefreshEnrichmentApiTokenMutation,
} from './RefreshEnrichmentApiTokenModal.gql';

import useAccountId from '~/hooks/useAccountId';
import useClassicFormBehavior from '~/hooks/useClassicFormBehavior';



const messages = defineMessages({
	description: {
		id: 'ui.teamDetail.accountSettings.changeEnrichmentApiHint',
	},
	submitButton: {
		id: 'ui.button.changeEnrichmentApiToken',
	},
	title: {
		id: 'ui.teamDetail.accountSettings.changeEnrichmentApiLink',
	},
});



const RefreshEnrichmentApiTokenModal: React.FC = () => {
	const accountId = useAccountId();
	const classicFormBehavior = useClassicFormBehavior();

	const [refreshEnrichmentApiToken] = useRefreshEnrichmentApiTokenMutation();

	const handleSubmit = React.useCallback(
		async () => {
			if (accountId === null) {
				return;
			}

			await refreshEnrichmentApiToken({
				variables: {
					accountId,
				},
			});

			classicFormBehavior.finish();
		},
		[
			accountId,
			classicFormBehavior,
			refreshEnrichmentApiToken,
		],
	);

	return (
		<ModalContainer
			header={(
				<ModalHeader
					title={(
						<FormattedMessage {...messages.title} />
					)}
				/>
			)}
		>
			<FormattedMessage {...messages.description} />

			<div className="modal__form">
				<Form
					defaultDataHasChanged={true}
					onSuccess={handleSubmit}
				>
					<ButtonsLayout>
						<CancelButton />

						<SubmitButton positive={false}>
							<FormattedMessage {...messages.submitButton} />
						</SubmitButton>
					</ButtonsLayout>
				</Form>
			</div>
		</ModalContainer>
	);
};



export default RefreshEnrichmentApiTokenModal;
